<template>
  <div>
    <p class="headline" v-html="$t('tutorial.stepAnswering.TITLE')"></p>
    <p class="subheading" style="text-align: justify" v-html="$t('tutorial.stepAnswering.BODY')"></p>
    <v-btn @click="next" v-bind:class="{blinking: !disableStartButton}" :disabled="disableStartButton">{{ $t('tutorial.buttons.START') }}</v-btn>
    <v-layout row wrap>
      <v-flex xs10 offset-xs1>
        <v-carousel style="height: 400px" :cycle="false" v-model="actualItem" :light="true" hide-delimiters>
          <v-carousel-item v-for="item in questionnaireItems" v-bind:src="''" :key="item.itemOrder"
                           reverse-transition="" transition="">
            <v-flex style="margin-left: 10%; margin-right: 10%">
              <v-card>
                <v-flex class="ma-4 pa-1">
                  <v-card >
                    <v-card-title>

                      <tutorial-tooltip lazy v-model="tooltips[7]" left>
                        <v-icon class="pl-1" slot="activator"
                                v-if="" color="primary"
                                v-bind:class="{blinking: tooltips[7], obscured: !tooltips[7] && disableStartButton}">star</v-icon>

                        <span v-html="$t('tutorial.stepAnswering.substeps.STEP7')"></span><br>
                        <v-btn small v-on:click="next()">{{ $t('tutorial.buttons.NEXT') }}</v-btn>
                      </tutorial-tooltip>

                      <span style="margin-left: auto; margin-right: 0;">
                        <tutorial-tooltip lazy v-model="tooltips[1]" right>
                          <v-btn small flat v-on:click="" slot="activator" v-bind:class="{blinking: tooltips[1], obscured: !tooltips[1] && disableStartButton}">
                            <span v-t="{path: 'info.scopes.SCOPE'+findItemById(items, item.itemId).scope+'.TITLE', locale: version}">
                            </span>
                            <v-icon right light small>info_outline</v-icon>
                          </v-btn>

                          <span v-html="$t('tutorial.stepAnswering.substeps.STEP1')"></span>
                          <v-spacer></v-spacer>
                          <v-btn small v-on:click="next()">{{ $t('tutorial.buttons.NEXT') }}</v-btn>
                        </tutorial-tooltip>
                      </span>
                    </v-card-title>

                    <v-card-title class="title" v-t="{path: 'ITEM'+item.itemId+'.TITLE', locale: version}"
                                  v-bind:class="{obscured: disableStartButton}">
                    </v-card-title>

                    <v-card-title>
                      <tutorial-tooltip lazy v-model="tooltips[3]" left>
                        <span slot="activator">
                          <h5 v-bind:class="{blinking: tooltips[3], obscured: !tooltips[3] && disableStartButton}">
                            <v-icon color="deep-purple lighten-4" v-if="findItemById(items, item.itemId).complexity == 1">radio_button_checked</v-icon>
                            <v-icon color="deep-purple lighten-4" v-if="findItemById(items, item.itemId).complexity != 1">radio_button_unchecked</v-icon>
                            <v-icon color="deep-purple lighten-1" v-if="findItemById(items, item.itemId).complexity == 2">radio_button_checked</v-icon>
                            <v-icon color="deep-purple lighten-1" v-if="findItemById(items, item.itemId).complexity != 2">radio_button_unchecked</v-icon>
                            <v-icon color="deep-purple darken-4" v-if="findItemById(items, item.itemId).complexity == 3">radio_button_checked</v-icon>
                            <v-icon color="deep-purple darken-4" v-if="findItemById(items, item.itemId).complexity != 3">radio_button_unchecked</v-icon>
                          </h5>
                        </span>

                        <span v-html="$t('tutorial.stepAnswering.substeps.STEP3')"></span><br>
                        <v-btn small v-on:click="next()">{{ $t('tutorial.buttons.NEXT') }}</v-btn>
                      </tutorial-tooltip>
                      <span style="margin-left: auto; margin-right: 0; cursor: pointer">
                        <tutorial-tooltip lazy v-model="tooltips[2]" right>
                            <v-icon slot="activator" v-bind:class="{blinking: tooltips[2], obscured: !tooltips[2] && disableStartButton}"
                                    class="subheading" v-on:click="showHelp(item.itemId)">info_outline</v-icon>

                          <span v-html="$t('tutorial.stepAnswering.substeps.STEP2')"></span><br>
                          <v-btn small v-on:click="next()">{{ $t('tutorial.buttons.NEXT') }}</v-btn>
                        </tutorial-tooltip>
                      </span>
                    </v-card-title>
                  </v-card>
                </v-flex>

                <tutorial-tooltip left v-model="tooltips[4]">
                  <v-card-actions slot="activator" class="text-xs-center" style="display: block" v-bind:class="{blinking: tooltips[4], obscured: (!tooltips[4] && disableStartButton) && (!tooltips[8] && disableStartButton) && (!tooltips[9] && disableStartButton) && (!tooltips[10] && disableStartButton)}">
                    <tutorial-tooltip left v-model="tooltips[8]">
                      <v-btn slot="activator" class="green--text pl-5 pr-5"  @click.native="answerItem(3)" v-if="!item.isAnswered"
                              >
                        <span class="headline"><v-icon color="green">sentiment_very_satisfied</v-icon></span>
                      </v-btn>
                      <span v-html="$t('tutorial.stepAnswering.substeps.STEP8')"></span>
                    </tutorial-tooltip>
                    <tutorial-tooltip lazy left v-model="tooltips[10]">
                      <v-btn slot="activator" class="orange--text pl-5 pr-5" @click.native="answerItem(2)" v-if="!item.isAnswered"
                             >
                        <span class="headline"><v-icon color="orange">sentiment_satisfied</v-icon></span>
                      </v-btn>
                      <span v-html="$t('tutorial.stepAnswering.substeps.STEP10')"></span>
                    </tutorial-tooltip>
                    <v-btn class="red--text pl-5 pr-5"  @click.native="answerItem(1)" v-if="!item.isAnswered"
                           >
                      <span class="headline"><v-icon color="red">sentiment_very_dissatisfied</v-icon></span>
                    </v-btn>
                    <tutorial-tooltip max-width="400" lazy v-model="tooltips[9]" left v-if="item.isAnswered">
                      <div slot="activator" />

                      <span v-html="$t('tutorial.stepAnswering.substeps.STEP9')"></span>
                    </tutorial-tooltip>
                    <v-btn class="green--text headline pl-5 pr-5" flat @click.native="" v-if="item.isAnswered" :disabled="item.answer != 3"
                    ><v-icon color="green">sentiment_very_satisfied</v-icon>
                    </v-btn>
                    <v-btn class="orange--text headline pl-5 pr-5" flat @click.native="" v-if="item.isAnswered" :disabled="item.answer != 2"
                    ><v-icon color="orange">sentiment_satisfied</v-icon>
                    </v-btn>
                    <v-btn class="red--text headline pl-5 pr-5" flat @click.native="" v-if="item.isAnswered"  :disabled="item.answer != 1"
                    ><v-icon color="red">sentiment_very_dissatisfied</v-icon>
                    </v-btn>
                      <v-btn lazy slot="activator" icon v-show="item.isAnswered" @click.native="undoAnswer()"
                             v-bind:class="{blinking: tooltips[9], obscured: (!tooltips[9] && disableStartButton)}"><v-icon>lock_open</v-icon></v-btn>

                  </v-card-actions>

                  <span v-html="$t('tutorial.stepAnswering.substeps.STEP4')"></span><br>
                  <v-btn small v-on:click="next()">{{ $t('tutorial.buttons.NEXT') }}</v-btn>
                </tutorial-tooltip>

                <tutorial-tooltip v-model="tooltips[5]" left>
                  <v-card-title slot="activator" v-bind:class="{blinking: tooltips[5], obscured: !tooltips[5] && disableStartButton}" >
                    <v-btn large color="primary" block v-on:click="">
                      <span v-t="{path: 'info.incorporateDialog.BUTTON', locale: version}"></span>
                      <v-icon light small right>live_help</v-icon>
                    </v-btn>
                  </v-card-title>
                  <span v-html="$t('tutorial.stepAnswering.substeps.STEP5')"></span><br>
                  <v-btn small v-on:click="next()">{{ $t('tutorial.buttons.NEXT') }}</v-btn>
                </tutorial-tooltip>
              </v-card>
            </v-flex>
          </v-carousel-item>
        </v-carousel>
      </v-flex>
      <v-flex xs12 sm12 md12 lg8 offset-lg2>
        <div class="text-xs-center">
          <tutorial-tooltip v-model="tooltips[6]" left>
            <v-pagination :length="20" v-model="paginationItem" circle
            slot="activator" v-bind:class="{blinking: tooltips[6], obscured: !tooltips[6] && disableStartButton}"></v-pagination>
            <span v-html="$t('tutorial.stepAnswering.substeps.STEP6')"></span><br>
            <v-btn small v-on:click="next()">{{ $t('tutorial.buttons.NEXT') }}</v-btn>
          </tutorial-tooltip>
        </div>
      </v-flex>
    </v-layout>
    <v-container>
      <v-layout>
        <v-btn @click.native="stepBack" flat>{{ $t('tutorial.buttons.BACK') }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn @click.native="stepForward" v-bind:class="{blinking: stepFinished}" :disabled="!stepFinished">{{ $t('tutorial.buttons.CONTINUE') }}</v-btn>
      </v-layout>
    </v-container>
    <v-dialog v-model="dialogError" max-width="290">
      <v-card>
        <v-card-title class="headline">{{ $t('tutorial.stepAnswering.ERROR') }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat="flat" @click.native="dialogError = false">{{ $t('tutorial.buttons.BACK') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<style>
  button .btn__content {
    white-space: inherit;
    flex: inherit;
  }
</style>
<script>
  import {ItemResource} from '@/api/item'
  import TutorialTooltip from '@/components/tutorial/TutorialTooltip'
  export default {
    components: {TutorialTooltip},
    name: 'tutorial-step7',
    data () {
      return {
        version: this.$auth.user().version,
        questionnaireItems: [
          { questionnaireId: 1, itemId: 11, itemOrder: 1, isAnswered: false, answer: null }
        ],
        items: [],
        actualItem: 0,
        tooltips: [true],
        step: 0,
        paginationItem: 1,
        dialogError: false
      }
    },
    created: function () {
      ItemResource().get().then(response => {
        this.items = response.body
      }, response => {
        console.log(response)
      })
    },
    computed: {
      disableStartButton: function () {
        return this.tooltips[0] === false
      },
      stepFinished: function () {
        return this.tooltips[11] === true
      }
    },
    methods: {
      findItemById: function (collection, itemId) {
        return this._.find(collection, function (i) {
          return i.id === itemId
        })
      },
      next: function () {
        this.$set(this.tooltips, this.step, false)
        this.step++
        this.$set(this.tooltips, this.step, true)
      },
      answerItem: function (answer) {
        if (answer === 3 && this.step === 8) {
          this.questionnaireItems[0].isAnswered = true
          this.questionnaireItems[0].answer = 3
          this.next()
        } else if (answer === 2 && this.step === 10) {
          this.questionnaireItems[0].isAnswered = true
          this.questionnaireItems[0].answer = 2
          this.next()
        } else {
          this.dialogError = true
        }
      },
      undoAnswer: function () {
        if (this.step === 9) {
          this.questionnaireItems[0].isAnswered = false
          this.questionnaireItems[0].answer = null
          this.next()
        }
      },
      stepBack: function () {
        this.resetStep()
        this.$emit('back')
      },
      stepForward: function () {
        this.resetStep()
        this.$emit('continue')
      },
      resetStep: function () {
        this.step = 0
        this.tooltips = [true]
        this.questionnaireItems[0].answer = null
        this.questionnaireItems[0].isAnswered = false
      }
    }
  }
</script>

<style scoped>
  .blinking {
    border: 3px solid #4caf50;
    animation: blink 1.3s ease-in infinite;
  }

  .blinking:hover {
    animation: none;
  }

  .obscured {
    opacity: 0.3;
  }

  @keyframes blink {
    from, to { opacity: 1 }
    50% { opacity: 0.1 }
  }
</style>



// WEBPACK FOOTER //
// src/components/tutorial/TutorialStep7.vue